import ExternalContainer from './external_container';

const External = ExternalContainer;
export default External;
